module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-galleria-item-wrapper"
  }, [_c('div', {
    staticClass: "p-galleria-item-container"
  }, [(_vm.showItemNavigators) ? _c('button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    class: _vm.navBackwardClass,
    attrs: {
      "type": "button",
      "disabled": _vm.isNavBackwardDisabled()
    },
    on: {
      "click": function($event) {
        return _vm.navBackward($event)
      }
    }
  }, [_c('span', {
    staticClass: "p-galleria-item-prev-icon pi pi-chevron-left"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-galleria-item"
  }, [_c('GalleriaItemSlot', {
    attrs: {
      "type": "item",
      "item": _vm.activeItem,
      "templates": _vm.templates
    }
  })], 1), _vm._v(" "), (_vm.showItemNavigators) ? _c('button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    class: _vm.navForwardClass,
    attrs: {
      "type": "button",
      "disabled": _vm.isNavForwardDisabled()
    },
    on: {
      "click": function($event) {
        return _vm.navForward($event)
      }
    }
  }, [_c('span', {
    staticClass: "p-galleria-item-next-icon pi pi-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.templates['caption']) ? _c('div', {
    staticClass: "p-galleria-caption"
  }, [_c('GalleriaItemSlot', {
    attrs: {
      "type": "caption",
      "item": _vm.activeItem,
      "templates": _vm.templates
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.showIndicators) ? _c('ul', {
    staticClass: "p-galleria-indicators p-reset"
  }, _vm._l((_vm.value), function(item, index) {
    return _c('li', {
      key: ("p-galleria-indicator-" + index),
      class: ['p-galleria-indicator', {
        'p-highlight': _vm.isIndicatorItemActive(index)
      }],
      attrs: {
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.onIndicatorClick(index)
        },
        "mouseenter": function($event) {
          return _vm.onIndicatorMouseEnter(index)
        },
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.onIndicatorKeyDown(index)
        }
      }
    }, [(!_vm.templates['indicator']) ? _c('button', {
      staticClass: "p-link",
      attrs: {
        "type": "button",
        "tabindex": "-1"
      }
    }) : _vm._e(), _vm._v(" "), _c('GalleriaItemSlot', {
      attrs: {
        "type": "indicator",
        "index": index,
        "templates": _vm.templates
      }
    })], 1)
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00d43240"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/galleria/GalleriaItem.vue
// module id = 2001
// module chunks = 0